/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AddStationDto,
  CreateFactoryDto,
  CreateZoneDto,
  EditStationDto,
  FactoriesControllerListFactoriesParams,
  FactoryComplexityMappingDto,
  FactoryDto,
  FactoryListItemDto,
  FactoryTopologyDto,
  RenameZoneDto,
  StationNodeDto,
  UpdateFactoryDto,
  ZoneNodeDto
} from '.././schemas';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Returns factories owned by the specified partner (by UUID), including is_archived. Callers must be a member of the requested partner; admins bypass this check.
 * @summary List factories for a partner
 */
export type factoriesControllerListFactoriesResponse200 = {
  data: FactoryListItemDto[]
  status: 200
}

export type factoriesControllerListFactoriesResponse400 = {
  data: void
  status: 400
}

export type factoriesControllerListFactoriesResponse401 = {
  data: void
  status: 401
}

export type factoriesControllerListFactoriesResponse403 = {
  data: void
  status: 403
}

export type factoriesControllerListFactoriesResponse404 = {
  data: void
  status: 404
}
    
export type factoriesControllerListFactoriesResponseSuccess = (factoriesControllerListFactoriesResponse200) & {
  headers: Headers;
};
export type factoriesControllerListFactoriesResponseError = (factoriesControllerListFactoriesResponse400 | factoriesControllerListFactoriesResponse401 | factoriesControllerListFactoriesResponse403 | factoriesControllerListFactoriesResponse404) & {
  headers: Headers;
};

export type factoriesControllerListFactoriesResponse = (factoriesControllerListFactoriesResponseSuccess | factoriesControllerListFactoriesResponseError)

export const getFactoriesControllerListFactoriesUrl = (params: FactoriesControllerListFactoriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/factories?${stringifiedParams}` : `/factories`
}

export const factoriesControllerListFactories = async (params: FactoriesControllerListFactoriesParams, options?: RequestInit): Promise<factoriesControllerListFactoriesResponse> => {
  
  return customFetch<factoriesControllerListFactoriesResponse>(getFactoriesControllerListFactoriesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getFactoriesControllerListFactoriesQueryKey = (params?: FactoriesControllerListFactoriesParams,) => {
    return [
    `/factories`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getFactoriesControllerListFactoriesQueryOptions = <TData = Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError = void>(params: FactoriesControllerListFactoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFactoriesControllerListFactoriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof factoriesControllerListFactories>>> = ({ signal }) => factoriesControllerListFactories(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type FactoriesControllerListFactoriesQueryResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerListFactories>>>
export type FactoriesControllerListFactoriesQueryError = void


export function useFactoriesControllerListFactories<TData = Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError = void>(
 params: FactoriesControllerListFactoriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof factoriesControllerListFactories>>,
          TError,
          Awaited<ReturnType<typeof factoriesControllerListFactories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFactoriesControllerListFactories<TData = Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError = void>(
 params: FactoriesControllerListFactoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof factoriesControllerListFactories>>,
          TError,
          Awaited<ReturnType<typeof factoriesControllerListFactories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFactoriesControllerListFactories<TData = Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError = void>(
 params: FactoriesControllerListFactoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List factories for a partner
 */

export function useFactoriesControllerListFactories<TData = Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError = void>(
 params: FactoriesControllerListFactoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getFactoriesControllerListFactoriesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List factories for a partner
 */
export const prefetchFactoriesControllerListFactoriesQuery = async <TData = Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError = void>(
 queryClient: QueryClient, params: FactoriesControllerListFactoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getFactoriesControllerListFactoriesQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getFactoriesControllerListFactoriesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError = void>(params: FactoriesControllerListFactoriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFactoriesControllerListFactoriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof factoriesControllerListFactories>>> = ({ signal }) => factoriesControllerListFactories(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type FactoriesControllerListFactoriesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerListFactories>>>
export type FactoriesControllerListFactoriesSuspenseQueryError = void


export function useFactoriesControllerListFactoriesSuspense<TData = Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError = void>(
 params: FactoriesControllerListFactoriesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFactoriesControllerListFactoriesSuspense<TData = Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError = void>(
 params: FactoriesControllerListFactoriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFactoriesControllerListFactoriesSuspense<TData = Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError = void>(
 params: FactoriesControllerListFactoriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List factories for a partner
 */

export function useFactoriesControllerListFactoriesSuspense<TData = Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError = void>(
 params: FactoriesControllerListFactoriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerListFactories>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getFactoriesControllerListFactoriesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a factory for the given partner. Restricted to Artic admins.
 * @summary Create a factory (Artic admin only)
 */
export type factoriesControllerCreateFactoryResponse201 = {
  data: FactoryDto
  status: 201
}

export type factoriesControllerCreateFactoryResponse403 = {
  data: void
  status: 403
}

export type factoriesControllerCreateFactoryResponse404 = {
  data: void
  status: 404
}

export type factoriesControllerCreateFactoryResponse409 = {
  data: void
  status: 409
}
    
export type factoriesControllerCreateFactoryResponseSuccess = (factoriesControllerCreateFactoryResponse201) & {
  headers: Headers;
};
export type factoriesControllerCreateFactoryResponseError = (factoriesControllerCreateFactoryResponse403 | factoriesControllerCreateFactoryResponse404 | factoriesControllerCreateFactoryResponse409) & {
  headers: Headers;
};

export type factoriesControllerCreateFactoryResponse = (factoriesControllerCreateFactoryResponseSuccess | factoriesControllerCreateFactoryResponseError)

export const getFactoriesControllerCreateFactoryUrl = () => {


  

  return `/factories`
}

export const factoriesControllerCreateFactory = async (createFactoryDto: CreateFactoryDto, options?: RequestInit): Promise<factoriesControllerCreateFactoryResponse> => {
  
  return customFetch<factoriesControllerCreateFactoryResponse>(getFactoriesControllerCreateFactoryUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createFactoryDto,)
  }
);}




export const getFactoriesControllerCreateFactoryMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerCreateFactory>>, TError,{data: CreateFactoryDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerCreateFactory>>, TError,{data: CreateFactoryDto}, TContext> => {

const mutationKey = ['factoriesControllerCreateFactory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoriesControllerCreateFactory>>, {data: CreateFactoryDto}> = (props) => {
          const {data} = props ?? {};

          return  factoriesControllerCreateFactory(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FactoriesControllerCreateFactoryMutationResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerCreateFactory>>>
    export type FactoriesControllerCreateFactoryMutationBody = CreateFactoryDto
    export type FactoriesControllerCreateFactoryMutationError = void

    /**
 * @summary Create a factory (Artic admin only)
 */
export const useFactoriesControllerCreateFactory = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerCreateFactory>>, TError,{data: CreateFactoryDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoriesControllerCreateFactory>>,
        TError,
        {data: CreateFactoryDto},
        TContext
      > => {

      const mutationOptions = getFactoriesControllerCreateFactoryMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns the labour-minute rows (complexity 1..5) configured for this factory. Callers must be a member of the factory-owning partner; admins bypass this check.
 * @summary List complexity-score → labour-minutes mappings for a factory
 */
export type factoriesControllerGetComplexityMappingsResponse200 = {
  data: FactoryComplexityMappingDto[]
  status: 200
}

export type factoriesControllerGetComplexityMappingsResponse404 = {
  data: void
  status: 404
}
    
export type factoriesControllerGetComplexityMappingsResponseSuccess = (factoriesControllerGetComplexityMappingsResponse200) & {
  headers: Headers;
};
export type factoriesControllerGetComplexityMappingsResponseError = (factoriesControllerGetComplexityMappingsResponse404) & {
  headers: Headers;
};

export type factoriesControllerGetComplexityMappingsResponse = (factoriesControllerGetComplexityMappingsResponseSuccess | factoriesControllerGetComplexityMappingsResponseError)

export const getFactoriesControllerGetComplexityMappingsUrl = (factoryId: string,) => {


  

  return `/factories/${factoryId}/complexity-mappings`
}

export const factoriesControllerGetComplexityMappings = async (factoryId: string, options?: RequestInit): Promise<factoriesControllerGetComplexityMappingsResponse> => {
  
  return customFetch<factoriesControllerGetComplexityMappingsResponse>(getFactoriesControllerGetComplexityMappingsUrl(factoryId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getFactoriesControllerGetComplexityMappingsQueryKey = (factoryId?: string,) => {
    return [
    `/factories/${factoryId}/complexity-mappings`
    ] as const;
    }

    
export const getFactoriesControllerGetComplexityMappingsQueryOptions = <TData = Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError = void>(factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFactoriesControllerGetComplexityMappingsQueryKey(factoryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>> = ({ signal }) => factoriesControllerGetComplexityMappings(factoryId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(factoryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type FactoriesControllerGetComplexityMappingsQueryResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>>
export type FactoriesControllerGetComplexityMappingsQueryError = void


export function useFactoriesControllerGetComplexityMappings<TData = Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError = void>(
 factoryId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>,
          TError,
          Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFactoriesControllerGetComplexityMappings<TData = Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>,
          TError,
          Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFactoriesControllerGetComplexityMappings<TData = Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List complexity-score → labour-minutes mappings for a factory
 */

export function useFactoriesControllerGetComplexityMappings<TData = Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getFactoriesControllerGetComplexityMappingsQueryOptions(factoryId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List complexity-score → labour-minutes mappings for a factory
 */
export const prefetchFactoriesControllerGetComplexityMappingsQuery = async <TData = Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError = void>(
 queryClient: QueryClient, factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getFactoriesControllerGetComplexityMappingsQueryOptions(factoryId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getFactoriesControllerGetComplexityMappingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError = void>(factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFactoriesControllerGetComplexityMappingsQueryKey(factoryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>> = ({ signal }) => factoriesControllerGetComplexityMappings(factoryId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type FactoriesControllerGetComplexityMappingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>>
export type FactoriesControllerGetComplexityMappingsSuspenseQueryError = void


export function useFactoriesControllerGetComplexityMappingsSuspense<TData = Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError = void>(
 factoryId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFactoriesControllerGetComplexityMappingsSuspense<TData = Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFactoriesControllerGetComplexityMappingsSuspense<TData = Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List complexity-score → labour-minutes mappings for a factory
 */

export function useFactoriesControllerGetComplexityMappingsSuspense<TData = Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetComplexityMappings>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getFactoriesControllerGetComplexityMappingsSuspenseQueryOptions(factoryId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns the factory with its zones, each containing its stations — the contents of one factory tab in the Factory Admin view. Includes archived zones/stations (flagged via is_archived). Callers must be a member of the factory-owning partner.
 * @summary Factory topology: zones with their stations
 */
export type factoriesControllerGetZonesResponse200 = {
  data: FactoryTopologyDto
  status: 200
}

export type factoriesControllerGetZonesResponse404 = {
  data: void
  status: 404
}
    
export type factoriesControllerGetZonesResponseSuccess = (factoriesControllerGetZonesResponse200) & {
  headers: Headers;
};
export type factoriesControllerGetZonesResponseError = (factoriesControllerGetZonesResponse404) & {
  headers: Headers;
};

export type factoriesControllerGetZonesResponse = (factoriesControllerGetZonesResponseSuccess | factoriesControllerGetZonesResponseError)

export const getFactoriesControllerGetZonesUrl = (factoryId: string,) => {


  

  return `/factories/${factoryId}/zones`
}

export const factoriesControllerGetZones = async (factoryId: string, options?: RequestInit): Promise<factoriesControllerGetZonesResponse> => {
  
  return customFetch<factoriesControllerGetZonesResponse>(getFactoriesControllerGetZonesUrl(factoryId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getFactoriesControllerGetZonesQueryKey = (factoryId?: string,) => {
    return [
    `/factories/${factoryId}/zones`
    ] as const;
    }

    
export const getFactoriesControllerGetZonesQueryOptions = <TData = Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError = void>(factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFactoriesControllerGetZonesQueryKey(factoryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof factoriesControllerGetZones>>> = ({ signal }) => factoriesControllerGetZones(factoryId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(factoryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type FactoriesControllerGetZonesQueryResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerGetZones>>>
export type FactoriesControllerGetZonesQueryError = void


export function useFactoriesControllerGetZones<TData = Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError = void>(
 factoryId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof factoriesControllerGetZones>>,
          TError,
          Awaited<ReturnType<typeof factoriesControllerGetZones>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFactoriesControllerGetZones<TData = Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof factoriesControllerGetZones>>,
          TError,
          Awaited<ReturnType<typeof factoriesControllerGetZones>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFactoriesControllerGetZones<TData = Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Factory topology: zones with their stations
 */

export function useFactoriesControllerGetZones<TData = Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getFactoriesControllerGetZonesQueryOptions(factoryId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Factory topology: zones with their stations
 */
export const prefetchFactoriesControllerGetZonesQuery = async <TData = Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError = void>(
 queryClient: QueryClient, factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getFactoriesControllerGetZonesQueryOptions(factoryId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getFactoriesControllerGetZonesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError = void>(factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFactoriesControllerGetZonesQueryKey(factoryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof factoriesControllerGetZones>>> = ({ signal }) => factoriesControllerGetZones(factoryId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type FactoriesControllerGetZonesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerGetZones>>>
export type FactoriesControllerGetZonesSuspenseQueryError = void


export function useFactoriesControllerGetZonesSuspense<TData = Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError = void>(
 factoryId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFactoriesControllerGetZonesSuspense<TData = Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFactoriesControllerGetZonesSuspense<TData = Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Factory topology: zones with their stations
 */

export function useFactoriesControllerGetZonesSuspense<TData = Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoriesControllerGetZones>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getFactoriesControllerGetZonesSuspenseQueryOptions(factoryId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a zone in a factory
 */
export type factoriesControllerCreateZoneResponse201 = {
  data: ZoneNodeDto
  status: 201
}

export type factoriesControllerCreateZoneResponse409 = {
  data: void
  status: 409
}
    
export type factoriesControllerCreateZoneResponseSuccess = (factoriesControllerCreateZoneResponse201) & {
  headers: Headers;
};
export type factoriesControllerCreateZoneResponseError = (factoriesControllerCreateZoneResponse409) & {
  headers: Headers;
};

export type factoriesControllerCreateZoneResponse = (factoriesControllerCreateZoneResponseSuccess | factoriesControllerCreateZoneResponseError)

export const getFactoriesControllerCreateZoneUrl = (factoryId: string,) => {


  

  return `/factories/${factoryId}/zones`
}

export const factoriesControllerCreateZone = async (factoryId: string,
    createZoneDto: CreateZoneDto, options?: RequestInit): Promise<factoriesControllerCreateZoneResponse> => {
  
  return customFetch<factoriesControllerCreateZoneResponse>(getFactoriesControllerCreateZoneUrl(factoryId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createZoneDto,)
  }
);}




export const getFactoriesControllerCreateZoneMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerCreateZone>>, TError,{factoryId: string;data: CreateZoneDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerCreateZone>>, TError,{factoryId: string;data: CreateZoneDto}, TContext> => {

const mutationKey = ['factoriesControllerCreateZone'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoriesControllerCreateZone>>, {factoryId: string;data: CreateZoneDto}> = (props) => {
          const {factoryId,data} = props ?? {};

          return  factoriesControllerCreateZone(factoryId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FactoriesControllerCreateZoneMutationResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerCreateZone>>>
    export type FactoriesControllerCreateZoneMutationBody = CreateZoneDto
    export type FactoriesControllerCreateZoneMutationError = void

    /**
 * @summary Create a zone in a factory
 */
export const useFactoriesControllerCreateZone = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerCreateZone>>, TError,{factoryId: string;data: CreateZoneDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoriesControllerCreateZone>>,
        TError,
        {factoryId: string;data: CreateZoneDto},
        TContext
      > => {

      const mutationOptions = getFactoriesControllerCreateZoneMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Renames a factory and/or changes its timezone. Restricted to Artic admins.
 * @summary Edit factory details (Artic admin only)
 */
export type factoriesControllerUpdateFactoryResponse200 = {
  data: FactoryDto
  status: 200
}

export type factoriesControllerUpdateFactoryResponse403 = {
  data: void
  status: 403
}

export type factoriesControllerUpdateFactoryResponse404 = {
  data: void
  status: 404
}

export type factoriesControllerUpdateFactoryResponse409 = {
  data: void
  status: 409
}
    
export type factoriesControllerUpdateFactoryResponseSuccess = (factoriesControllerUpdateFactoryResponse200) & {
  headers: Headers;
};
export type factoriesControllerUpdateFactoryResponseError = (factoriesControllerUpdateFactoryResponse403 | factoriesControllerUpdateFactoryResponse404 | factoriesControllerUpdateFactoryResponse409) & {
  headers: Headers;
};

export type factoriesControllerUpdateFactoryResponse = (factoriesControllerUpdateFactoryResponseSuccess | factoriesControllerUpdateFactoryResponseError)

export const getFactoriesControllerUpdateFactoryUrl = (factoryId: string,) => {


  

  return `/factories/${factoryId}`
}

export const factoriesControllerUpdateFactory = async (factoryId: string,
    updateFactoryDto: UpdateFactoryDto, options?: RequestInit): Promise<factoriesControllerUpdateFactoryResponse> => {
  
  return customFetch<factoriesControllerUpdateFactoryResponse>(getFactoriesControllerUpdateFactoryUrl(factoryId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateFactoryDto,)
  }
);}




export const getFactoriesControllerUpdateFactoryMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUpdateFactory>>, TError,{factoryId: string;data: UpdateFactoryDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUpdateFactory>>, TError,{factoryId: string;data: UpdateFactoryDto}, TContext> => {

const mutationKey = ['factoriesControllerUpdateFactory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoriesControllerUpdateFactory>>, {factoryId: string;data: UpdateFactoryDto}> = (props) => {
          const {factoryId,data} = props ?? {};

          return  factoriesControllerUpdateFactory(factoryId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FactoriesControllerUpdateFactoryMutationResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerUpdateFactory>>>
    export type FactoriesControllerUpdateFactoryMutationBody = UpdateFactoryDto
    export type FactoriesControllerUpdateFactoryMutationError = void

    /**
 * @summary Edit factory details (Artic admin only)
 */
export const useFactoriesControllerUpdateFactory = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUpdateFactory>>, TError,{factoryId: string;data: UpdateFactoryDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoriesControllerUpdateFactory>>,
        TError,
        {factoryId: string;data: UpdateFactoryDto},
        TContext
      > => {

      const mutationOptions = getFactoriesControllerUpdateFactoryMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Archive a factory (Artic admin only)
 */
export type factoriesControllerArchiveFactoryResponse201 = {
  data: FactoryDto
  status: 201
}
    
export type factoriesControllerArchiveFactoryResponseSuccess = (factoriesControllerArchiveFactoryResponse201) & {
  headers: Headers;
};
;

export type factoriesControllerArchiveFactoryResponse = (factoriesControllerArchiveFactoryResponseSuccess)

export const getFactoriesControllerArchiveFactoryUrl = (factoryId: string,) => {


  

  return `/factories/${factoryId}/archive`
}

export const factoriesControllerArchiveFactory = async (factoryId: string, options?: RequestInit): Promise<factoriesControllerArchiveFactoryResponse> => {
  
  return customFetch<factoriesControllerArchiveFactoryResponse>(getFactoriesControllerArchiveFactoryUrl(factoryId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getFactoriesControllerArchiveFactoryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerArchiveFactory>>, TError,{factoryId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerArchiveFactory>>, TError,{factoryId: string}, TContext> => {

const mutationKey = ['factoriesControllerArchiveFactory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoriesControllerArchiveFactory>>, {factoryId: string}> = (props) => {
          const {factoryId} = props ?? {};

          return  factoriesControllerArchiveFactory(factoryId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FactoriesControllerArchiveFactoryMutationResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerArchiveFactory>>>
    
    export type FactoriesControllerArchiveFactoryMutationError = unknown

    /**
 * @summary Archive a factory (Artic admin only)
 */
export const useFactoriesControllerArchiveFactory = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerArchiveFactory>>, TError,{factoryId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoriesControllerArchiveFactory>>,
        TError,
        {factoryId: string},
        TContext
      > => {

      const mutationOptions = getFactoriesControllerArchiveFactoryMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Unarchive a factory (Artic admin only)
 */
export type factoriesControllerUnarchiveFactoryResponse201 = {
  data: FactoryDto
  status: 201
}
    
export type factoriesControllerUnarchiveFactoryResponseSuccess = (factoriesControllerUnarchiveFactoryResponse201) & {
  headers: Headers;
};
;

export type factoriesControllerUnarchiveFactoryResponse = (factoriesControllerUnarchiveFactoryResponseSuccess)

export const getFactoriesControllerUnarchiveFactoryUrl = (factoryId: string,) => {


  

  return `/factories/${factoryId}/unarchive`
}

export const factoriesControllerUnarchiveFactory = async (factoryId: string, options?: RequestInit): Promise<factoriesControllerUnarchiveFactoryResponse> => {
  
  return customFetch<factoriesControllerUnarchiveFactoryResponse>(getFactoriesControllerUnarchiveFactoryUrl(factoryId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getFactoriesControllerUnarchiveFactoryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUnarchiveFactory>>, TError,{factoryId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUnarchiveFactory>>, TError,{factoryId: string}, TContext> => {

const mutationKey = ['factoriesControllerUnarchiveFactory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoriesControllerUnarchiveFactory>>, {factoryId: string}> = (props) => {
          const {factoryId} = props ?? {};

          return  factoriesControllerUnarchiveFactory(factoryId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FactoriesControllerUnarchiveFactoryMutationResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerUnarchiveFactory>>>
    
    export type FactoriesControllerUnarchiveFactoryMutationError = unknown

    /**
 * @summary Unarchive a factory (Artic admin only)
 */
export const useFactoriesControllerUnarchiveFactory = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUnarchiveFactory>>, TError,{factoryId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoriesControllerUnarchiveFactory>>,
        TError,
        {factoryId: string},
        TContext
      > => {

      const mutationOptions = getFactoriesControllerUnarchiveFactoryMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Rename a zone
 */
export type factoriesControllerRenameZoneResponse200 = {
  data: void
  status: 200
}

export type factoriesControllerRenameZoneResponse409 = {
  data: void
  status: 409
}
    
export type factoriesControllerRenameZoneResponseSuccess = (factoriesControllerRenameZoneResponse200) & {
  headers: Headers;
};
export type factoriesControllerRenameZoneResponseError = (factoriesControllerRenameZoneResponse409) & {
  headers: Headers;
};

export type factoriesControllerRenameZoneResponse = (factoriesControllerRenameZoneResponseSuccess | factoriesControllerRenameZoneResponseError)

export const getFactoriesControllerRenameZoneUrl = (factoryId: string,
    zoneId: string,) => {


  

  return `/factories/${factoryId}/zones/${zoneId}`
}

export const factoriesControllerRenameZone = async (factoryId: string,
    zoneId: string,
    renameZoneDto: RenameZoneDto, options?: RequestInit): Promise<factoriesControllerRenameZoneResponse> => {
  
  return customFetch<factoriesControllerRenameZoneResponse>(getFactoriesControllerRenameZoneUrl(factoryId,zoneId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      renameZoneDto,)
  }
);}




export const getFactoriesControllerRenameZoneMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerRenameZone>>, TError,{factoryId: string;zoneId: string;data: RenameZoneDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerRenameZone>>, TError,{factoryId: string;zoneId: string;data: RenameZoneDto}, TContext> => {

const mutationKey = ['factoriesControllerRenameZone'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoriesControllerRenameZone>>, {factoryId: string;zoneId: string;data: RenameZoneDto}> = (props) => {
          const {factoryId,zoneId,data} = props ?? {};

          return  factoriesControllerRenameZone(factoryId,zoneId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FactoriesControllerRenameZoneMutationResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerRenameZone>>>
    export type FactoriesControllerRenameZoneMutationBody = RenameZoneDto
    export type FactoriesControllerRenameZoneMutationError = void

    /**
 * @summary Rename a zone
 */
export const useFactoriesControllerRenameZone = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerRenameZone>>, TError,{factoryId: string;zoneId: string;data: RenameZoneDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoriesControllerRenameZone>>,
        TError,
        {factoryId: string;zoneId: string;data: RenameZoneDto},
        TContext
      > => {

      const mutationOptions = getFactoriesControllerRenameZoneMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Archive a zone
 */
export type factoriesControllerArchiveZoneResponse201 = {
  data: void
  status: 201
}
    
export type factoriesControllerArchiveZoneResponseSuccess = (factoriesControllerArchiveZoneResponse201) & {
  headers: Headers;
};
;

export type factoriesControllerArchiveZoneResponse = (factoriesControllerArchiveZoneResponseSuccess)

export const getFactoriesControllerArchiveZoneUrl = (factoryId: string,
    zoneId: string,) => {


  

  return `/factories/${factoryId}/zones/${zoneId}/archive`
}

export const factoriesControllerArchiveZone = async (factoryId: string,
    zoneId: string, options?: RequestInit): Promise<factoriesControllerArchiveZoneResponse> => {
  
  return customFetch<factoriesControllerArchiveZoneResponse>(getFactoriesControllerArchiveZoneUrl(factoryId,zoneId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getFactoriesControllerArchiveZoneMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerArchiveZone>>, TError,{factoryId: string;zoneId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerArchiveZone>>, TError,{factoryId: string;zoneId: string}, TContext> => {

const mutationKey = ['factoriesControllerArchiveZone'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoriesControllerArchiveZone>>, {factoryId: string;zoneId: string}> = (props) => {
          const {factoryId,zoneId} = props ?? {};

          return  factoriesControllerArchiveZone(factoryId,zoneId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FactoriesControllerArchiveZoneMutationResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerArchiveZone>>>
    
    export type FactoriesControllerArchiveZoneMutationError = unknown

    /**
 * @summary Archive a zone
 */
export const useFactoriesControllerArchiveZone = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerArchiveZone>>, TError,{factoryId: string;zoneId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoriesControllerArchiveZone>>,
        TError,
        {factoryId: string;zoneId: string},
        TContext
      > => {

      const mutationOptions = getFactoriesControllerArchiveZoneMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Unarchive a zone
 */
export type factoriesControllerUnarchiveZoneResponse201 = {
  data: void
  status: 201
}
    
export type factoriesControllerUnarchiveZoneResponseSuccess = (factoriesControllerUnarchiveZoneResponse201) & {
  headers: Headers;
};
;

export type factoriesControllerUnarchiveZoneResponse = (factoriesControllerUnarchiveZoneResponseSuccess)

export const getFactoriesControllerUnarchiveZoneUrl = (factoryId: string,
    zoneId: string,) => {


  

  return `/factories/${factoryId}/zones/${zoneId}/unarchive`
}

export const factoriesControllerUnarchiveZone = async (factoryId: string,
    zoneId: string, options?: RequestInit): Promise<factoriesControllerUnarchiveZoneResponse> => {
  
  return customFetch<factoriesControllerUnarchiveZoneResponse>(getFactoriesControllerUnarchiveZoneUrl(factoryId,zoneId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getFactoriesControllerUnarchiveZoneMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUnarchiveZone>>, TError,{factoryId: string;zoneId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUnarchiveZone>>, TError,{factoryId: string;zoneId: string}, TContext> => {

const mutationKey = ['factoriesControllerUnarchiveZone'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoriesControllerUnarchiveZone>>, {factoryId: string;zoneId: string}> = (props) => {
          const {factoryId,zoneId} = props ?? {};

          return  factoriesControllerUnarchiveZone(factoryId,zoneId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FactoriesControllerUnarchiveZoneMutationResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerUnarchiveZone>>>
    
    export type FactoriesControllerUnarchiveZoneMutationError = unknown

    /**
 * @summary Unarchive a zone
 */
export const useFactoriesControllerUnarchiveZone = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUnarchiveZone>>, TError,{factoryId: string;zoneId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoriesControllerUnarchiveZone>>,
        TError,
        {factoryId: string;zoneId: string},
        TContext
      > => {

      const mutationOptions = getFactoriesControllerUnarchiveZoneMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Create a station in a zone
 */
export type factoriesControllerCreateStationResponse201 = {
  data: StationNodeDto
  status: 201
}

export type factoriesControllerCreateStationResponse409 = {
  data: void
  status: 409
}
    
export type factoriesControllerCreateStationResponseSuccess = (factoriesControllerCreateStationResponse201) & {
  headers: Headers;
};
export type factoriesControllerCreateStationResponseError = (factoriesControllerCreateStationResponse409) & {
  headers: Headers;
};

export type factoriesControllerCreateStationResponse = (factoriesControllerCreateStationResponseSuccess | factoriesControllerCreateStationResponseError)

export const getFactoriesControllerCreateStationUrl = (factoryId: string,
    zoneId: string,) => {


  

  return `/factories/${factoryId}/zones/${zoneId}/stations`
}

export const factoriesControllerCreateStation = async (factoryId: string,
    zoneId: string,
    addStationDto: AddStationDto, options?: RequestInit): Promise<factoriesControllerCreateStationResponse> => {
  
  return customFetch<factoriesControllerCreateStationResponse>(getFactoriesControllerCreateStationUrl(factoryId,zoneId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addStationDto,)
  }
);}




export const getFactoriesControllerCreateStationMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerCreateStation>>, TError,{factoryId: string;zoneId: string;data: AddStationDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerCreateStation>>, TError,{factoryId: string;zoneId: string;data: AddStationDto}, TContext> => {

const mutationKey = ['factoriesControllerCreateStation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoriesControllerCreateStation>>, {factoryId: string;zoneId: string;data: AddStationDto}> = (props) => {
          const {factoryId,zoneId,data} = props ?? {};

          return  factoriesControllerCreateStation(factoryId,zoneId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FactoriesControllerCreateStationMutationResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerCreateStation>>>
    export type FactoriesControllerCreateStationMutationBody = AddStationDto
    export type FactoriesControllerCreateStationMutationError = void

    /**
 * @summary Create a station in a zone
 */
export const useFactoriesControllerCreateStation = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerCreateStation>>, TError,{factoryId: string;zoneId: string;data: AddStationDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoriesControllerCreateStation>>,
        TError,
        {factoryId: string;zoneId: string;data: AddStationDto},
        TContext
      > => {

      const mutationOptions = getFactoriesControllerCreateStationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Renames a station and/or moves it to another zone within the same factory. Name must remain unique within the destination zone.
 * @summary Rename and/or move a station
 */
export type factoriesControllerUpdateStationResponse200 = {
  data: void
  status: 200
}

export type factoriesControllerUpdateStationResponse400 = {
  data: void
  status: 400
}

export type factoriesControllerUpdateStationResponse409 = {
  data: void
  status: 409
}
    
export type factoriesControllerUpdateStationResponseSuccess = (factoriesControllerUpdateStationResponse200) & {
  headers: Headers;
};
export type factoriesControllerUpdateStationResponseError = (factoriesControllerUpdateStationResponse400 | factoriesControllerUpdateStationResponse409) & {
  headers: Headers;
};

export type factoriesControllerUpdateStationResponse = (factoriesControllerUpdateStationResponseSuccess | factoriesControllerUpdateStationResponseError)

export const getFactoriesControllerUpdateStationUrl = (factoryId: string,
    zoneId: string,
    stationId: string,) => {


  

  return `/factories/${factoryId}/zones/${zoneId}/stations/${stationId}`
}

export const factoriesControllerUpdateStation = async (factoryId: string,
    zoneId: string,
    stationId: string,
    editStationDto: EditStationDto, options?: RequestInit): Promise<factoriesControllerUpdateStationResponse> => {
  
  return customFetch<factoriesControllerUpdateStationResponse>(getFactoriesControllerUpdateStationUrl(factoryId,zoneId,stationId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      editStationDto,)
  }
);}




export const getFactoriesControllerUpdateStationMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUpdateStation>>, TError,{factoryId: string;zoneId: string;stationId: string;data: EditStationDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUpdateStation>>, TError,{factoryId: string;zoneId: string;stationId: string;data: EditStationDto}, TContext> => {

const mutationKey = ['factoriesControllerUpdateStation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoriesControllerUpdateStation>>, {factoryId: string;zoneId: string;stationId: string;data: EditStationDto}> = (props) => {
          const {factoryId,zoneId,stationId,data} = props ?? {};

          return  factoriesControllerUpdateStation(factoryId,zoneId,stationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FactoriesControllerUpdateStationMutationResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerUpdateStation>>>
    export type FactoriesControllerUpdateStationMutationBody = EditStationDto
    export type FactoriesControllerUpdateStationMutationError = void

    /**
 * @summary Rename and/or move a station
 */
export const useFactoriesControllerUpdateStation = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUpdateStation>>, TError,{factoryId: string;zoneId: string;stationId: string;data: EditStationDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoriesControllerUpdateStation>>,
        TError,
        {factoryId: string;zoneId: string;stationId: string;data: EditStationDto},
        TContext
      > => {

      const mutationOptions = getFactoriesControllerUpdateStationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Archive a station
 */
export type factoriesControllerArchiveStationResponse201 = {
  data: void
  status: 201
}
    
export type factoriesControllerArchiveStationResponseSuccess = (factoriesControllerArchiveStationResponse201) & {
  headers: Headers;
};
;

export type factoriesControllerArchiveStationResponse = (factoriesControllerArchiveStationResponseSuccess)

export const getFactoriesControllerArchiveStationUrl = (factoryId: string,
    zoneId: string,
    stationId: string,) => {


  

  return `/factories/${factoryId}/zones/${zoneId}/stations/${stationId}/archive`
}

export const factoriesControllerArchiveStation = async (factoryId: string,
    zoneId: string,
    stationId: string, options?: RequestInit): Promise<factoriesControllerArchiveStationResponse> => {
  
  return customFetch<factoriesControllerArchiveStationResponse>(getFactoriesControllerArchiveStationUrl(factoryId,zoneId,stationId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getFactoriesControllerArchiveStationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerArchiveStation>>, TError,{factoryId: string;zoneId: string;stationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerArchiveStation>>, TError,{factoryId: string;zoneId: string;stationId: string}, TContext> => {

const mutationKey = ['factoriesControllerArchiveStation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoriesControllerArchiveStation>>, {factoryId: string;zoneId: string;stationId: string}> = (props) => {
          const {factoryId,zoneId,stationId} = props ?? {};

          return  factoriesControllerArchiveStation(factoryId,zoneId,stationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FactoriesControllerArchiveStationMutationResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerArchiveStation>>>
    
    export type FactoriesControllerArchiveStationMutationError = unknown

    /**
 * @summary Archive a station
 */
export const useFactoriesControllerArchiveStation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerArchiveStation>>, TError,{factoryId: string;zoneId: string;stationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoriesControllerArchiveStation>>,
        TError,
        {factoryId: string;zoneId: string;stationId: string},
        TContext
      > => {

      const mutationOptions = getFactoriesControllerArchiveStationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Unarchive a station
 */
export type factoriesControllerUnarchiveStationResponse201 = {
  data: void
  status: 201
}
    
export type factoriesControllerUnarchiveStationResponseSuccess = (factoriesControllerUnarchiveStationResponse201) & {
  headers: Headers;
};
;

export type factoriesControllerUnarchiveStationResponse = (factoriesControllerUnarchiveStationResponseSuccess)

export const getFactoriesControllerUnarchiveStationUrl = (factoryId: string,
    zoneId: string,
    stationId: string,) => {


  

  return `/factories/${factoryId}/zones/${zoneId}/stations/${stationId}/unarchive`
}

export const factoriesControllerUnarchiveStation = async (factoryId: string,
    zoneId: string,
    stationId: string, options?: RequestInit): Promise<factoriesControllerUnarchiveStationResponse> => {
  
  return customFetch<factoriesControllerUnarchiveStationResponse>(getFactoriesControllerUnarchiveStationUrl(factoryId,zoneId,stationId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getFactoriesControllerUnarchiveStationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUnarchiveStation>>, TError,{factoryId: string;zoneId: string;stationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUnarchiveStation>>, TError,{factoryId: string;zoneId: string;stationId: string}, TContext> => {

const mutationKey = ['factoriesControllerUnarchiveStation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoriesControllerUnarchiveStation>>, {factoryId: string;zoneId: string;stationId: string}> = (props) => {
          const {factoryId,zoneId,stationId} = props ?? {};

          return  factoriesControllerUnarchiveStation(factoryId,zoneId,stationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FactoriesControllerUnarchiveStationMutationResult = NonNullable<Awaited<ReturnType<typeof factoriesControllerUnarchiveStation>>>
    
    export type FactoriesControllerUnarchiveStationMutationError = unknown

    /**
 * @summary Unarchive a station
 */
export const useFactoriesControllerUnarchiveStation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoriesControllerUnarchiveStation>>, TError,{factoryId: string;zoneId: string;stationId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoriesControllerUnarchiveStation>>,
        TError,
        {factoryId: string;zoneId: string;stationId: string},
        TContext
      > => {

      const mutationOptions = getFactoriesControllerUnarchiveStationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    